import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-flex flex-column ml-3" }

import { defineComponent, h } from 'vue';
import { VLabel } from 'vuetify/components/VLabel';
import { Element } from '../models/component';

interface List {
  /* Component List */
  avatar: { props?: Element['props'], icon: Element },
  line1: Element,
  line2: Element,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    avatar: null,
    line1: null,
    line2: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  /* Component List */
  avatar: { props?: Element['props'], icon: Element },
  line1: Element,
  line2: Element,
};

defineComponent({ name: 'CwList' });



const cwListChild1 = {
  render() {
    return h(props.line1.component ?? VLabel, props.line1.props, props.line1.text ?? undefined);
  },
};
const cwListChild2 = {
  render() {
    return h(props.line2.component ?? 'span', props.line2.props, props.line2.text ?? undefined);
  },
};

expose({ cwListChild1, cwListChild2 });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_avatar, _mergeProps(__props.avatar.props, {
      color: __props.avatar.props?.color ?? 'primary',
      size: __props.avatar.props?.size ?? 50
    }), {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(__props.avatar.icon?.props)), null, 16)
      ]),
      _: 1
    }, 16, ["color", "size"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(cwListChild1), _normalizeProps(_guardReactiveProps(__props.line1.props)), null, 16)),
      (_openBlock(), _createBlock(_resolveDynamicComponent(cwListChild2), _normalizeProps(_guardReactiveProps(__props.line2.props)), null, 16))
    ])
  ]))
}
}

})